const queryKeys = {
  connections: () => ['settings', 'connections'] as const,
  connection: (id: string) => [...queryKeys.connections(), id] as const,
};

export default queryKeys;
